<script setup>
    import Layout from "@/layouts/main.vue";
    import PageHeader from "@/components/page-header";
    import '@jobinsjp/vue3-datatable/dist/style.css';
    import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
    import { computed, onMounted, ref } from 'vue';
    import { useStore } from 'vuex';
import axios from "axios";

    const store = useStore();
    const loading = computed(() => store.state.globals.loading);
    const viewBatches = computed(() => store.state.ovr.viewBatches);
    const pagination = computed(() => store.state.ovr.viewBatchesPagination);
    const title = ref("View Batch");
    const items = ref([
        {
            text: "Home",
            href: "/"
        },
        {
            text: "OVR",
        },
        {
            text: "View Batch",
            active: true,
        }
    ]);

    const query = ref({
        search: ''        
    });

    const cutoffTime = ref(null);

    const getAllViewBatches = async (dt) => {
        await store.dispatch('ovr/getAllViewBatches', {
            page: dt.page,
            pageSize: dt.per_page ,
            sortColumn: 'id',
            search: dt.search,
            orderBy: 'desc'
        });
    }

    const getBatchCutOff = async () => {
        try {
            const { data } = await axios.get('ovr/view/batch/cut-off');
            cutoffTime.value = data.data['cut-off'];
        } catch (err) {
            console.log(err);
            cutoffTime.value = null
        }

    }

    onMounted(() => {
        getBatchCutOff();
    })
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-overlay :show="loading">
        <div class="d-flex mb-4 justify-content-between">
          <div>
            <h1 class="fs-4 text">View Batch</h1>
            <small>Get all the OVR batches</small>
          </div>
        </div>

        <div class="row">
            <div class="col lg-12">
                <data-table
                    :rows="viewBatches"
                    :pagination="pagination"
                    striped
                    :loading="loading"
                    :query="query"
                    filter
                    hoverable
                    sortable
                    @loadData="getAllViewBatches"
                    >

                    <template #thead>
                        <table-head>Batch ID</table-head>
                        <table-head>LGU</table-head>
                        <table-head>Batch No.</table-head>
                        <table-head>Batch Count</table-head>
                        <table-head>Manifest</table-head>
                    </template>

                    <template #tbody="{row}">
                        <table-body v-text="row.id" />
                        <table-body v-text="row.lgu && row.lgu.name ? row.lgu.name : 'N/A'" />
                        <table-body v-text="row.batch_number" />
                        <table-body v-text="row.batch_count" />
                        <table-body>
                          <span :class="row.is_approved ? 'text-success' : 'text-info'">{{ row.is_approved ? 'Batch Approved' : `Batch will automatically cutoff at ${cutoffTime? cutoffTime : '08:00 PM'}` }}</span>
                        </table-body>
                    </template>

                    <template #empty>
                    <TableBodyCell colspan="10">
                        No View Batch found!
                    </TableBodyCell>
                </template>
                </data-table>
            </div>
        </div>
      </b-overlay>
  </Layout>
</template>